import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { makeStateKey, TransferState } from '@angular/platform-browser';

const DATA_KEY = makeStateKey<any>('post-renderer-data-state');

@Component({
  selector: 'app-app-seo-location-page',
  templateUrl: './app-seo-location-page.component.html',
  styleUrls: ['./app-seo-location-page.component.scss'],
})
export class AppSeoLocationPageComponent implements OnInit {
  resolvedData: any;
  hasPostsPage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private transferState: TransferState,
  ) {}

  ngOnInit(): void {
    this.resolvedData = this.route.snapshot.data.SeoLocationPageResolve;
    this.transferState.set(DATA_KEY, this.resolvedData);
    this.hasPostsPage = !!this.resolvedData?.trailingUrl;
  }
}
